import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6b83015a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "customs"
};
const _hoisted_2 = {
  class: "customs__header"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "采购信息", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "customs__hr"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_ellipsis_text = _resolveComponent("ellipsis-text");
  const _component_t_table = _resolveComponent("t-table");
  const _component_t_pagination = _resolveComponent("t-pagination");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    class: "logo-wrapper",
    src: require('@/assets/img/customer/us-customs.png'),
    alt: "customs"
  }, null, 8, _hoisted_3), _hoisted_4]), _hoisted_5, _createVNode(_component_t_table, {
    loading: _ctx.tableLoading,
    data: _ctx.tableData,
    "row-class-name": _ctx.tableRowClassName
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "date",
      label: "日期",
      "min-width": "104px"
    }), _createVNode(_component_el_table_column, {
      prop: "consigneeName",
      label: "采购商",
      "min-width": "241px"
    }, {
      default: _withCtx(({
        row
      }) => [_createVNode(_component_ellipsis_text, {
        "hide-immediately": true
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(row.consigneeName), 1)]),
        _: 2
      }, 1024)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "shipperName",
      label: "供应商",
      "min-width": "241px"
    }, {
      default: _withCtx(({
        row
      }) => [_createVNode(_component_ellipsis_text, {
        "hide-immediately": true
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(row.shipperName), 1)]),
        _: 2
      }, 1024)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "productDesc",
      label: "详细信息",
      "min-width": "391px"
    }, {
      default: _withCtx(({
        row
      }) => [_createVNode(_component_ellipsis_text, {
        "hide-immediately": true
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(row.productDesc), 1)]),
        _: 2
      }, 1024)]),
      _: 1
    })]),
    _: 1
  }, 8, ["loading", "data", "row-class-name"]), _createVNode(_component_t_pagination, {
    "current-page": _ctx.currentPage,
    "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => _ctx.currentPage = $event),
    "page-size": _ctx.currentPageSize,
    "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => _ctx.currentPageSize = $event),
    class: "customs__pagination",
    layout: "total, prev, pager, next",
    total: _ctx.totalCount,
    onCurrentChange: _ctx.fetchTableData
  }, null, 8, ["current-page", "page-size", "total", "onCurrentChange"])], 512)), [[_vShow, _ctx.tableData.length]]);
}